import { Component } from '@angular/core';

@Component({
  selector: 'app-ex-footer',
  templateUrl: './ex-footer.component.html',
  styleUrls: ['./ex-footer.component.css']
})
export class ExFooterComponent {

}
